import { Fichier } from "./fichier";
import { Projet } from "./projet";
import { Site } from "./site";

export class Dossier {
  dossierId: number;
  nom: string;
  dossierParentId: number;
  siteId: number;
  projetId: number;
  dossierParent: Dossier;
  site: Site;
  stepId?: number;
  projet: Projet;
  sousDossiers: Dossier[];
  fichiers: Fichier[];
  isSelected:boolean;
  getTotalFilesInDossier(): number {
    let totalFiles = 0;

    // Count files in this dossier
    totalFiles += this.fichiers?.length || 0;

    // Recursively count files in sub-dossiers
    if (this.sousDossiers && this.sousDossiers.length > 0) {
      totalFiles += this.sousDossiers.reduce((sum, sousDossier) => 
        sum + sousDossier.getTotalFilesInDossier(), 0);
    }

    return totalFiles;
  }
}
